import { IMapTelemetry, NOOP_MAP_TELEMETRY } from './createMapTelemetry';

/**
 * Единственный на страницу экземпляр фасада телеметрии.
 *
 * Держим его здесь, а не создаём в каждой точке вызова, по двум причинам.
 * Слой пинов живёт вне React и не может получить фасад через контекст.
 * И разрезы метрик должны быть одинаковыми во всей сессии: у компонентов и у кода вне дерева
 * разные источники типа устройства, и собственный фасад в каждой точке давал бы расхождение.
 */
let mapTelemetry: IMapTelemetry | null = null;

export function setMapTelemetry(instance: IMapTelemetry | null) {
  mapTelemetry = instance;
}

/**
 * До инициализации и на сервере отдаёт пустую реализацию,
 * чтобы вызывающий код не проверял наличие фасада на каждом вызове.
 */
export function getMapTelemetry(): IMapTelemetry {
  return mapTelemetry || NOOP_MAP_TELEMETRY;
}
